import { AppRoute } from '@agentselly/immodossier-shared';
import { regionWidgets } from '~/config/widgets/regionWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_DOSSIER_REGION,
  regionWidgets,
  true,
);
